import { useDataSourceStore } from '@/store/dataSourceStore';
import ability from '@/libs/acl/ability';
import { initialAbility } from '@/libs/acl/config';
import tagModel from '@/models/tag/tags';
import apiService from '@/services/api';

class DataSourceService {
  private get dataSourceStore() {
    return useDataSourceStore();
  }

  async fetchdataSources(): Promise<any[]> {
    const { getCDPDataSourceModel } = tagModel();
    try {
      const resp = await apiService.apiRequest(getCDPDataSourceModel);
      return resp.data as any[];
    } catch (e) {
      // Handle or rethrow the error as needed
      console.error('Error fetching dataSources:', e);
      throw e;
    }
  }

  async fetchAndSetdataSources() {
    try {
      const dataSource = await this.fetchdataSources();

      // Update the Info state in a single operation
      this.dataSourceStore.setDataSource(dataSource);
    } catch (e) {
      console.error('Error updating dataSources:', e);
      // Set initial from config
      this.dataSourceStore.resetDataSources();
    }
  }
}

const dataSourceService = new DataSourceService();
export default dataSourceService;
